'use client';

import React from 'react';

interface MarqueeBannerProps {
  text: string;
}

const MarqueeBanner: React.FC<MarqueeBannerProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <div className="marquee-banner">
      <div className="marquee-content">
        <div className="marquee-text">
          {text}
        </div>
      </div>
    </div>
  );
};

export default MarqueeBanner;
